// @flow

import Notifications from '../constants/Notifications';
import { Component } from '../jsti/core';

export default class CarouselSliderBullets extends Component {
  activeClass: string = 'carousel-slider__item--active';

  /**
   * Get the carousel slider items
   */
  get items(): Array<HTMLLIElement> {
    return [...this.el.children];
  }

  /**
   * Instantiate the bullets components
   */
  bind(pEl: HTMLElement) {
    super.bind(pEl);
    this.addListener(Notifications.UPDATE_CAROUSEL_BULLETS, this.handleUpdate.bind(this));
    this.addListener(Notifications.CAROUSEL_CHANGE_INDEX, this.toggleBullets.bind(this));
    this.addListener(Notifications.CAROUSEL_UPDATE_NAVIGATION, this.toggleBullets.bind(this));
  }

  /**
   * Handle the incoming update notification
   */
  handleUpdate({ mediaCount }: { mediaCount: number }): void {
    this.rebuildComponent(mediaCount);
  }

  /**
   * Toggle the bullets. Changes the active state
   */
  toggleBullets(pData: Object): void {
    this.items.forEach((element: HTMLLIElement) => element.classList.remove(this.activeClass));

    const item = this.items[pData.index] || this.items[0];
    item.classList.add(this.activeClass);
  }

  /**
   * Rebuild the component
   */
  rebuildComponent(count: number): void {
    this.el.innerHTML = '';
    for (let i = 0; i < count; i++) {
      const span = document.createElement('span');
      span.dataset.index = i.toString();
      span.dataset.component = 'carousel-slider-button';
      this.el.appendChild(span);
    }
  }
}
